import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const YoutubeCircle32: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(s.svg32, `svg-icon--${icon}`)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={getDataIconAttribute(chroma, icon, '32')}
  >
    <path
      className={cn(
        chroma === 'default' && s.youtubeFill,
        chroma === 'dark' && s.lightFill,
        chroma === 'light' && s.darkFill
      )}
      d="M15.84 1.44c7.947 0 14.4 6.453 14.4 14.4s-6.453 14.4-14.4 14.4-14.4-6.453-14.4-14.4 6.453-14.4 14.4-14.4zm.157 9.392h-.373c-.835.004-4.236.035-5.172.286A1.717 1.717 0 009.24 12.33c-.251.935-.282 2.76-.286 3.201v.196c.004.442.035 2.266.286 3.202.157.59.622 1.054 1.212 1.212.97.26 4.583.284 5.252.286h.214c.669-.002 4.282-.027 5.251-.286a1.717 1.717 0 001.213-1.212c.251-.936.282-2.76.286-3.202v-.196c-.004-.441-.035-2.266-.286-3.201a1.717 1.717 0 00-1.213-1.212c-.935-.25-4.336-.282-5.172-.286zm-1.41 2.708l3.444 2.035-3.443 2.035v-4.07z"
      fillRule="evenodd"
    />
  </svg>
);

export default YoutubeCircle32;
